import React, { Component } from 'react';
import $ from 'jquery';
import Config from './Config';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, InputGroup, Input } from 'reactstrap';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import Header from '../components/Header';
import Editor from '../components/Editor';
import NewPrinterDestinationModal from '../components/modals/NewPrinterDestinationModal';
import TemplateEditorModal from '../components/modals/TemplateEditorModal'
import DestinationsTable from '../components/tables/DestinationsTable'
import { connect } from 'react-redux';
import AuthHOC from './Auth';
import { withAlert } from 'react-alert';
import { Flag } from 'flagger/react';
import { Stack, Typography, Button as MuiButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

class PrinterDestinationsView extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.onDropDownclick = this.onDropDownclick.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.showNewDestinationModal = this.showNewDestinationModal.bind(this)
    this.addNewDestination = this.addNewDestination.bind(this)
    this.showTemplateEditorModal = this.showTemplateEditorModal.bind(this)
    this.refresh = this.refresh.bind(this)

    this.state = {
      dropdownOpen: false,
      destinations: [],
      displayDestincationEditorModal: false,
      displayNewDestinationModal: false
    };
  }

  componentDidMount() {
    fetch(window.location.protocol + '//' + window.location.host + '/api/printing/destinations')
      .then(res => res.json())
      .then(result => {
        this.setState({
          destinations: result.destinations
        })
      })
  }

  addNewDestination(group, folder, destination, printers, users) {
    try {
      var bdy = {};
      bdy.group = group;
      bdy.folder = folder;
      bdy.destination = destination;
      bdy.printers = printers;
      bdy.printer_users = users;
      //bdy.client = client;
      //bdy.printerName = printerName;

      fetch(window.location.protocol + '//' + window.location.host + "/api/printing/x3printers",
        {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(bdy)
        })
        .then(res => res.json())
        .then(result => {
          this.props.alert.success("Created destination");
          this.refresh();
        })
    }
    catch (error) {
      this.props.alert.error(error.message);
    }

    //close the modal
    this.showNewDestinationModal()

  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  onDropDownclick(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    //$('#html-toggle').html(this.children);
    let template = this.state.destinations.find(element => {
      return element.template == name
    })

    this.setState({
      template: template.template,
      html: template.html
    })
  }

  handleInputChange(html) {
    this.setState({
      html: html
    })
  }

  handleRawInputChange(html) {
    this.setState({
      rawhtml: html
    })
  }

  activateHtmlButton() {
    this.setState({
      text: !this.state.text
    })
  }

  showNewDestinationModal() {
    this.setState({
      displayNewDestinationModal: !this.state.displayNewDestinationModal
    })
  }

  showTemplateEditorModal() {
    this.setState({
      displayTemplateEditorModal: !this.state.displayDestincationEditorModal
    })
  }

  refresh() {
    this.setState({
      checkedLogs: [],
      logs: []
    });

    this.getDestinations()
  }

  getDestinations() {
    fetch(window.location.protocol + '//' + window.location.host + '/api/printing/destinations')
      .then(res => res.json())
      .then(result => {
        this.setState({
          destinations: result.destinations
        })
      })
  }


  render() {
    const { parsed, localisation } = this.props

    let newDestModal = <NewPrinterDestinationModal visible={this.state.displayNewDestinationModal} toggle={this.showNewDestinationModal} newDestination={this.addNewDestination} />

    return (
      <div className="App">
        <Header visible={!this.props.parsed.X3} />
        <div className="page-wrapper">
        <div className="s-page">
          <div className="s-page-header">
            <Stack spacing={0.5} alignItems="flex-start" sx={{ mb: 3, textAlign: "left" }}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {localisation['printing_destination_header'] ? localisation['printing_destination_header'].element_lang : 'Print Destinations'}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Manage print destinations and printer connections
              </Typography>
            </Stack>
            <div className="s-page-actions">
              <Flag flag="v12" entity={{ id: 1 }} case="off">
                <MuiButton
                  variant="contained"
                  startIcon={<AddIcon />}
                  disableElevation
                  type="button"
                  sx={{ textTransform: 'none' }}
                  onClick={this.showNewDestinationModal}
                >
                  {localisation['new_destination_button'] ? localisation['new_destination_button'].element_lang : ''}
                </MuiButton>
              </Flag>
              <Flag flag="v12" entity={{ id: 1 }} case="on">
                <MuiButton
                  variant="contained"
                  startIcon={<AddIcon />}
                  disableElevation
                  type="button"
                  sx={{ textTransform: 'none' }}
                  onClick={this.showNewDestinationModal}
                >
                  {localisation['new_destination_button'] ? localisation['new_destination_button'].element_lang : ''}
                </MuiButton>
              </Flag>
            </div>
          </div>
          <div className="s-content-panel">
          <InputGroup>
            <div className="text-editor" style={{ width: '100%' }}>
              <DestinationsTable
                delete={this.remove}
                refresh={this.refresh}
                onRowClicked={this.rowClicked}
                logs={this.state.destinations}
                columnConfig={{ actions: true }}
              />
            </div>
          </InputGroup>
          {newDestModal}
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(AuthHOC(withAlert()(PrinterDestinationsView), { name: 'print_destinations' }));
